export class ClientError extends Error {
  constructor(response, request) {
    const message = "".concat(ClientError.extractMessage(response), ": ").concat(JSON.stringify({
      response,
      request
    }));
    super(message);
    Object.setPrototypeOf(this, ClientError.prototype);
    this.response = response;
    this.request = request;
    // this is needed as Safari doesn't support .captureStackTrace
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, ClientError);
    }
  }
  static extractMessage(response) {
    var _response$errors$0$me, _response$errors;
    return (_response$errors$0$me = (_response$errors = response.errors) === null || _response$errors === void 0 || (_response$errors = _response$errors[0]) === null || _response$errors === void 0 ? void 0 : _response$errors.message) !== null && _response$errors$0$me !== void 0 ? _response$errors$0$me : "GraphQL Error (Code: ".concat(response.status, ")");
  }
}